module.exports = __webpack_public_path__ + "img/9791185971018.d1779974.jpg";